'use strict';
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var check_1 = require("./check");
var util_1 = require("./util");
var Obj;
(function (Obj) {
    function invert(object) {
        return Object.entries(object).reduce(function (obj, _a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            return (__assign({}, obj, (_c = {}, _c[value] = key, _c)));
            var _c;
        }, {});
    }
    Obj.invert = invert;
    function filter(collection, iterator) {
        if (!check_1.Check.isObjectLike(collection)) {
            return {};
        }
        var callback;
        callback = check_1.Check.isString(iterator) ? util_1.Util.property(iterator) : iterator;
        var result = {};
        Object
            .keys(collection)
            .forEach(function (key) {
            if (callback(collection[key], key, collection)) {
                result[key] = collection[key];
            }
        });
        return result;
    }
    Obj.filter = filter;
    function forEach(collection, iterator) {
        if (!check_1.Check.isObjectLike(collection)) {
            return {};
        }
        Object
            .keys(collection)
            .forEach(function (key) {
            iterator(collection[key], key, collection);
        });
        return collection;
    }
    Obj.forEach = forEach;
    function get(object, path, onFail, delimiter) {
        if (delimiter === void 0) { delimiter = '.'; }
        if (!check_1.Check.isObjectLike(object)) {
            return onFail;
        }
        var parts = path.split(delimiter);
        var currentObject = Object.assign({}, object);
        try {
            for (var parts_1 = __values(parts), parts_1_1 = parts_1.next(); !parts_1_1.done; parts_1_1 = parts_1.next()) {
                var part = parts_1_1.value;
                if (!check_1.Check.isPropertyExists(currentObject, part)) {
                    return onFail;
                }
                currentObject = currentObject[part];
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (parts_1_1 && !parts_1_1.done && (_a = parts_1.return)) _a.call(parts_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return currentObject;
        var e_1, _a;
    }
    Obj.get = get;
    function has(object, propertyName, notNilOnly) {
        if (notNilOnly === void 0) { notNilOnly = false; }
        if (object === null) {
            return false;
        }
        if (!(propertyName in object)) {
            return false;
        }
        if (!notNilOnly) {
            return true;
        }
        if (check_1.Check.isNil(object[propertyName])) {
            return false;
        }
        return true;
    }
    Obj.has = has;
    function mapValues(collection, iterator) {
        if (!check_1.Check.isObjectLike(collection)) {
            return {};
        }
        var callback;
        callback = check_1.Check.isString(iterator) ? util_1.Util.property(iterator) : iterator;
        var result = {};
        Object
            .keys(collection)
            .forEach(function (key) {
            result[key] = callback(collection[key], key, collection);
        });
        return result;
    }
    Obj.mapValues = mapValues;
    function pickAsArray(object, names) {
        if (!check_1.Check.isObjectLike(object)) {
            return [];
        }
        return names.map(function (name) { return object[name]; });
    }
    Obj.pickAsArray = pickAsArray;
    function remove(object, path, delimiter) {
        if (delimiter === void 0) { delimiter = '.'; }
        if (!check_1.Check.isAssignable(object)) {
            return false;
        }
        var parts = path.split(delimiter);
        if (parts.length === 1) {
            delete object[parts[0]];
            return true;
        }
        var property = parts[0];
        if (!check_1.Check.isPropertyExists(object, property)) {
            return false;
        }
        if (!check_1.Check.isPlainObject(object[property])) {
            return false;
        }
        return remove(object[property], parts.slice(1).join(delimiter));
    }
    Obj.remove = remove;
    function set(object, path, value, delimiter) {
        if (delimiter === void 0) { delimiter = '.'; }
        if (!check_1.Check.isAssignable(object)) {
            return false;
        }
        var parts = path.split(delimiter);
        if (parts.length === 1) {
            object[parts[0]] = value;
            return true;
        }
        var property = parts[0];
        if (check_1.Check.isPropertyExists(object, property)) {
            if (!check_1.Check.isPlainObject(object[property])) {
                object[property] = {};
            }
        }
        else {
            object[property] = {};
        }
        return set(object[property], parts.slice(1).join(delimiter), value);
    }
    Obj.set = set;
    function setIfEmpty(object, path, value, delimiter) {
        if (delimiter === void 0) { delimiter = '.'; }
        if (!check_1.Check.isAssignable(object)) {
            return false;
        }
        if (get(object, path, undefined) !== undefined) {
            return true;
        }
        return set(object, path, value, delimiter);
    }
    Obj.setIfEmpty = setIfEmpty;
    function push(object, path, value, delimiter, force) {
        if (delimiter === void 0) { delimiter = '.'; }
        if (force === void 0) { force = true; }
        var array = Obj.get(object, path, undefined, delimiter);
        if (check_1.Check.isArray(array)) {
            array.push(value);
            return set(object, path, array, delimiter);
        }
        if (array === undefined || force) {
            array = [value];
            return set(object, path, array, delimiter);
        }
        return false;
    }
    Obj.push = push;
})(Obj = exports.Obj || (exports.Obj = {}));



//////////////////
// WEBPACK FOOTER
// ./src/typescripts/shared/utils/obj.ts
// module id = 5
// module chunks = 0 1